import { GlobalStore } from "@roc/feature-app-core";
import { makeObservable, flow, observable, action } from "mobx";
import { LogBaseService } from "@roc/feature-app-core";
import { AutomationEventTypes } from "@roc/feature-insurance-review";
import { AIDocType } from "@roc/feature-documents";
import { LogInternalService } from "apps/roc-internal-portal/src/app/services/logInternalService";
import { getTypeKey } from "../utils/utils";


export class ReviewLogStore {
  public globalStore: GlobalStore;
  private logEventsList: Map<string, any> = new Map();
  protected logService: LogBaseService;

  constructor(globalStore: GlobalStore) {
    this.globalStore = globalStore;
    this.logService = new LogInternalService();
    makeObservable(this, {
      logEvents: flow,
      addEvent: action,
      reset: action
    });
  }

  reset() {
    this.logEventsList = new Map();
  }

  addEvent({ docType, mapping, sectionName, itemDisplayName, value, borrowerId }: {
    docType: AIDocType;
    mapping: string;
    sectionName?: string;
    itemDisplayName: string;
    value?: any;
    borrowerId?: number
  }) {
    switch (mapping) {
      case 'sendForRevision':
        const flagAction = value
          ? AutomationEventTypes.ITEM_REVISION_FLAGGED_EVENT
          : AutomationEventTypes.ITEM_REVISION_UNFLAGGED_EVENT;

        this.logEventsList.set(
          `FLAG-${sectionName}-${itemDisplayName}`,
          {
            reviewType: getTypeKey(docType),
            actionPerformed: flagAction,
            sectionName: sectionName,
            itemName: itemDisplayName,
            incomingValue: value,
          }
        );
        break;
      case 'needsRevisionFlag':
        const revisionAction = value
          ? AutomationEventTypes.ITEM_FLAGGED_EVENT
          : AutomationEventTypes.ITEM_UNFLAGGED_EVENT;

        this.logEventsList.set(
          `REVISION-${sectionName}-${itemDisplayName}`,
          {
            reviewType: getTypeKey(docType),
            actionPerformed: revisionAction,
            sectionName: sectionName,
            itemName: itemDisplayName,
            incomingValue: value
          }
        );
        break;
      case 'data':
        this.logEventsList.set(
          `${AutomationEventTypes.ITEM_DATA_UPDATED}-${sectionName}-${itemDisplayName}`,
          {
            reviewType: getTypeKey(docType),
            actionPerformed: AutomationEventTypes.ITEM_DATA_UPDATED,
            sectionName: sectionName,
            borrowerId: borrowerId,
            itemName: itemDisplayName,
            incomingValue: value,
          }
        );
    }
  }

  *logEvents(loanId: number, docType: AIDocType) {
    try {
      yield this.logService.logEvents(loanId, getTypeKey(docType), [...this.logEventsList.values()],);
      this.reset();
    } catch (e) {
      console.error('Error logging events', e);
    }
  }
}